import { InputTypes } from "../InputTypes";
import { OptionsSources } from "../OptionsSources";
import { Doctor } from "../doctors/Doctor";
import { numberToString } from "../parseUtils";
import { User } from "../users/User";

export const UserAppointment = Object.freeze({
  doctor_id: {
    visibleName: "Nutricionista",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: Doctor,
      property: Doctor._id,
      visibleProperty: Doctor.name,
      filter: () => {
        return true;
      },
    },
  },
  hora_cita: {
    visibleName: "Hora",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.INLINE,
      options: buildOptions(),
      filter: () => {
        return true;
      },
    },
  },
  horas_reservadas: {
    visibleName: "Fecha",
    type: InputTypes.DATE,
  },
});

export const UserAppointmentDoctor = Object.freeze({
  user_id: {
    visibleName: "Usuario",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.COLLECTION,
      collection: User,
      property: User._id,
      visibleProperty: User.name,
      filter: (v) => {
       return true
       
      },
    },
  },
  hora_cita: {
    visibleName: "Hora",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.INLINE,
      options: buildOptions(),
    },
  },
  horas_reservadas: {
    visibleName: "Fecha",
    type: InputTypes.DATE,
  },
  llamar: {
    visibleName: "Llamar",
    type: InputTypes.VIDEOCALL,
    callback: "callUser",
  },
  toString: "userAppointment",
});

function buildOptions() {
  const firstHour = 9;
  const lastHour = 20;
  let options = [];
  for (let i = firstHour; i <= lastHour; i++) {
    for (let j = 0; j <= 30; j += 30) {
      options.push({
        value: `${numberToString(i, 2)}:${numberToString(j, 2)}`,
        label: `${numberToString(i, 2)}:${numberToString(j, 2)}`,
      });
    }
  }
  return options;
}

export const SpecificUserAppointment = (usedHours) => {
  let specificAppointment = JSON.parse(JSON.stringify(UserAppointment));
  specificAppointment.hora_cita.optionsMapping.filter = (hour) => {
    return !usedHours?.includes(hour?.value); /*return true;*/
  };
  return specificAppointment;
};

export const SpecificUserIdAppointment = (userId) => {
  let specificAppointment = JSON.parse(JSON.stringify(UserAppointment));
  specificAppointment.user_id = userId;
  specificAppointment.toString = "userAppointment " + userId;
  return specificAppointment;
};
